// extracted by mini-css-extract-plugin
module.exports = {"themeControl":"ThemeSwitcher_themeControl__25BLa","themeLabel":"ThemeSwitcher_themeLabel__2E-DO","themeSelect":"ThemeSwitcher_themeSelect__1cui9"};